<template>
  <Modal :visible="!!state" :title="state?.title" size="md" closeText="Prekliči" @close="answer(false)">
    <p class="mb-0" style="white-space: pre-line">{{ state?.message }}</p>
    <template #buttons>
      <button type="button" :class="'btn btn-' + (state?.variant || 'primary')" @click="answer(true)">
        {{ state?.confirmText }}
      </button>
    </template>
  </Modal>
</template>

<script setup>
import { useConfirm, answer } from "./Confirm"

defineOptions({ name: "ConfirmDialog" })

const { state } = useConfirm()
</script>
